export function formatDate(date) {
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'long' });
  const getOrdinal = (n) => {
    if (n > 3 && n < 21) return 'th';
    switch (n % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  return `${day}${getOrdinal(day)} of ${month}`;
}

export function getTodayDate() {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, '0');
  const day = String(today.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function isToday(dateString) {
  if (!dateString) return false;
  return dateString === getTodayDate();
}

export function isFutureDate(dateString) {
  if (!dateString) return false;
  return dateString > getTodayDate();
}
